import { render, staticRenderFns } from "./DebugComponent.vue?vue&type=template&id=364760eb&"
import script from "./DebugComponent.vue?vue&type=script&lang=js&"
export * from "./DebugComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports